import { LockOutlined, WarningOutlined } from "@ant-design/icons";
import { Alert, Button, Input, Modal, Space, Typography, message } from "antd";
import { useState } from "react";
import api from "../services/api";

const { Title, Paragraph } = Typography;

export default function TOTPDisableModal({ open, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");

  const handleDisable = async () => {
    if (!verifyCode) {
      message.error("Please enter your password");
      return;
    }

    try {
      setLoading(true);

      await api.post("/auth/totp/disable", {
        password: verifyCode,
      });

      message.success("2FA disabled successfully");
      onSuccess?.();
      onClose();
      setVerifyCode("");
    } catch (error) {
      console.error("Failed to disable TOTP:", error);
      message.error(error.message || "Invalid password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Disable Two-Factor Authentication"
      open={open}
      onCancel={() => {
        onClose();
        setVerifyCode("");
      }}
      width={500}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onClose();
            setVerifyCode("");
          }}
        >
          Cancel
        </Button>,
        <Button
          key="disable"
          type="primary"
          danger
          onClick={handleDisable}
          loading={loading}
          disabled={verifyCode.length !== 6}
          icon={<WarningOutlined />}
        >
          Disable 2FA
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Alert
          message="Warning"
          description="Disabling 2FA will make your account less secure. You'll only need your password to log in."
          type="warning"
          showIcon
          icon={<WarningOutlined />}
        />

        <div>
          <Title level={4}>Enter your password to confirm:</Title>
          <Input.Password
            size="large"
            placeholder="Enter your password"
            value={verifyCode}
            onChange={(e) => setVerifyCode(e.target.value)}
            style={{ fontSize: "16px" }}
            autoFocus
            onPressEnter={handleDisable}
            prefix={<LockOutlined />}
          />
        </div>

        <Paragraph type="secondary">
          Enter your account password to disable Two-Factor Authentication.
        </Paragraph>
      </Space>
    </Modal>
  );
}
